import FilterAltIcon from '@mui/icons-material/FilterAlt';
import useFilterContext from './useFilterContext';
import IconButton from '../IconButton';
const FilterButton = () => {
  const { onOpenPopup } = useFilterContext();
  return <IconButton onClick={onOpenPopup} icon={<FilterAltIcon sx={{ color: '#307BFF' }} />} />;
};

export default FilterButton;
